__turbopack_context__.v({
  "container": "ErrorState-module-scss-module__xrzcBq__container",
  "illustration": "ErrorState-module-scss-module__xrzcBq__illustration",
});
